import * as React from "react"
const FertilizerSmall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="fs_Lager_1"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".fs_st0{display:none}.fs_st1{display:inline}.fs_st5{fill:none;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}.fs_st13,.fs_st14,.fs_st5,.fs_st8,.fs_st9{stroke:#2d0e5e;stroke-miterlimit:10}.fs_st8{fill:none;stroke-width:2}.fs_st13,.fs_st14,.fs_st9{stroke-linecap:round}.fs_st9{fill:none;stroke-width:2}.fs_st13,.fs_st14{stroke-linejoin:round}.fs_st13{fill:none;stroke-width:1.5}.fs_st14{fill:#2d0e5e}.fs_st16{fill:#e2d7b7}.fs_st17{fill:#5b480e}.fs_st19{fill:#4d4d4d}.fs_st20{fill:#2e2e8d}.fs_st22{display:inline;fill:#dff4f0}.fs_st23{fill:#a8ae5d}.fs_st24{fill:#c7e18f}.fs_st25{display:inline;fill:#fff}.fs_st27,.fs_st28,.fs_st29{fill:#072e44;stroke:#072e44;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.fs_st28,.fs_st29{fill:#13496d;stroke:#13496d}.fs_st29{fill:#a9c6dd;stroke:#a9c6dd}.fs_st32{fill:#13496d}.fs_st33{fill:#c4e8f7;stroke:#c4e8f7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.fs_st37{fill:#cebb9c}.fs_st38,.fs_st39,.fs_st40,.fs_st41{fill:none;stroke:#13496d;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.fs_st39,.fs_st40,.fs_st41{fill:#072e44;stroke:#072e44;stroke-width:1;stroke-miterlimit:9.9998}.fs_st40,.fs_st41{fill:#c4e8f7;stroke:#c4e8f7}.fs_st41{stroke-miterlimit:10}"
      }
    </style>
    <g id="fs_Lager_3">
      <ellipse
        cx={585.6}
        cy={526}
        className="fs_st16"
        rx={127.5}
        ry={434.1}
        transform="matrix(.00598 -1 1 .00598 56.115 1108.385)"
      />
      <path
        d="M282.3 458.2C272.7 433.4 253 430 253 430c1.1 1.7 7.9 15.8 10.7 28.2"
        className="fs_st16"
      />
      <path
        d="M282.3 461.2c-1.2 0-2.3-.7-2.8-1.9-5.5-14.3-14.5-21-20.6-24 2.6 5.9 6 14.5 7.7 22.3.4 1.6-.6 3.2-2.3 3.6-1.6.4-3.2-.6-3.6-2.3-2.7-12.2-9.4-25.9-10.3-27.2-.6-1-.6-2.3 0-3.3.7-1 1.8-1.5 3-1.3.9.2 21.5 4 31.6 30.1.6 1.5-.2 3.3-1.7 3.9-.3 0-.6.1-1 .1z"
        className="fs_st17"
      />
      <path
        d="M282.3 458.2c0-26.7 9.6-53.5 9.6-53.5s-1.4 43.1 6.8 63.6"
        className="fs_st16"
      />
      <path
        d="M298.7 471.3c-1.2 0-2.3-.7-2.8-1.9-4.5-11.4-6.2-29.1-6.8-43.1-2 9.3-3.8 20.7-3.8 31.9 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-26.9 9.4-53.4 9.8-54.5.5-1.4 1.9-2.2 3.4-1.9 1.5.3 2.5 1.6 2.4 3 0 .4-1.3 42.7 6.6 62.4.6 1.5-.1 3.3-1.7 3.9-.4.1-.7.2-1.1.2z"
        className="fs_st17"
      />
      <path
        d="M298.7 468.4c0-13 13.2-31.8 13.2-31.8s-6.2 24.2-3.4 31.8"
        className="fs_st16"
      />
      <path
        d="M308.5 471.4c-1.2 0-2.4-.8-2.8-2-1.2-3.4-1-9.3-.3-15.1-2.1 4.8-3.7 9.8-3.7 14.1 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-13.8 13.2-32.7 13.7-33.5.8-1.2 2.4-1.6 3.7-1 1.3.6 2 2.1 1.7 3.5-2.3 9-5.3 25.1-3.5 30 .6 1.6-.2 3.3-1.8 3.9-.3 0-.7.1-1 .1z"
        className="fs_st17"
      />
      <path
        d="M862.7 443.5c-8.2-24.8-25.1-28.2-25.1-28.2 1 1.7 6.8 15.8 9.2 28.2"
        className="fs_st16"
      />
      <path
        d="M862.7 446.5c-1.3 0-2.4-.8-2.8-2.1-4.4-13.4-11.5-20.1-16.6-23.3 2.2 5.8 5 14.1 6.4 21.8.3 1.6-.7 3.2-2.4 3.5-1.6.3-3.2-.8-3.5-2.4-2.3-12-7.9-25.7-8.8-27.2-.6-1-.5-2.3.2-3.3s1.9-1.4 3-1.2c.8.2 18.7 4 27.4 30.2.5 1.6-.3 3.3-1.9 3.8-.4.2-.7.2-1 .2z"
        className="fs_st17"
      />
      <path
        d="M862.7 442.3c0-17.8 14.4-35.5 14.4-35.5s-2.1 28.6 10.2 42.3"
        className="fs_st16"
      />
      <path
        d="M887.3 452.1c-.8 0-1.6-.3-2.2-1-8.3-9.3-10.5-24.5-11-34.5-3.9 6.5-8.4 16.2-8.4 25.7 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-18.7 14.5-36.6 15.1-37.4.8-1 2.2-1.4 3.4-.9 1.2.5 2 1.7 1.9 3 0 .3-1.9 27.5 9.4 40.1 1.1 1.2 1 3.1-.2 4.2-.6.5-1.3.8-2 .8z"
        className="fs_st17"
      />
      <path
        d="M887.3 449c0-8.6 19.9-21.1 19.9-21.1s-9.3 16.1-5.1 21.1"
        className="fs_st16"
      />
      <path
        d="M902.1 452c-.9 0-1.7-.4-2.3-1.1-2.7-3.3-1.9-8.8-.1-13.9-6.4 5.4-9.4 9.9-9.4 12 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-4.6 3.6-9.8 11-16.1 5.1-4.3 10.1-7.4 10.3-7.6 1.2-.7 2.7-.6 3.7.4s1.2 2.5.5 3.7c-4.3 7.5-6.9 15.9-5.4 17.7 1.1 1.3.9 3.2-.4 4.2-.5.5-1.2.7-1.9.7z"
        className="fs_st17"
      />
      <path
        d="M846 572.6c-.5-17.7-15.5-23.2-15.5-23.2.5 1.2 2.2 11.3.4 20.1"
        className="fs_st16"
      />
      <path
        d="M846 575.6c-1.6 0-3-1.3-3-2.9-.3-9.1-4.8-14.5-8.5-17.5.4 4.2.4 9.8-.6 14.9-.3 1.6-1.9 2.7-3.5 2.3-1.6-.3-2.7-1.9-2.3-3.5 1.6-7.9.2-17.1-.3-18.4-.5-1.1-.2-2.3.6-3.2.8-.9 2.1-1.1 3.2-.7.7.3 16.9 6.4 17.5 25.9-.1 1.7-1.4 3.1-3.1 3.1.1 0 0 0 0 0z"
        className="fs_st17"
      />
      <path
        d="M846.5 571.7c6.6-12.7 23-26.8 23-26.8s-9.2 11.9.4 21.7"
        className="fs_st16"
      />
      <path
        d="M846.5 574.7c-.5 0-.9-.1-1.4-.3-1.5-.8-2-2.6-1.3-4 6.8-13.1 23-27.1 23.7-27.7 1.2-1 2.9-1 4 .1s1.2 2.8.3 4c-.3.4-7.5 10 .2 17.8 1.2 1.2 1.1 3.1 0 4.2-1.2 1.2-3.1 1.1-4.2 0-4-4.1-5.3-8.7-5.2-13-4.8 5-10.3 11.4-13.4 17.4-.6.9-1.6 1.5-2.7 1.5z"
        className="fs_st17"
      />
      <path
        d="M322.5 567.3c.5-17.7 15.5-23.2 15.5-23.2-.5 1.2-2.2 11.3-.4 20.1"
        className="fs_st16"
      />
      <path
        d="M322.5 570.3s-.1 0 0 0c-1.7 0-3-1.4-3-3.1.6-19.5 16.8-25.7 17.5-25.9 1.1-.4 2.4-.1 3.2.7.8.9 1.1 2.1.6 3.2-.4 1.2-1.8 10.4-.2 18.3.3 1.6-.7 3.2-2.3 3.5-1.6.3-3.2-.7-3.5-2.3-1.1-5.2-1-10.7-.6-14.9-3.8 3-8.3 8.4-8.5 17.5-.2 1.7-1.6 3-3.2 3z"
        className="fs_st17"
      />
      <path
        d="M322 566.4c-6.6-12.7-23-26.8-23-26.8s9.2 11.9-.4 21.7"
        className="fs_st16"
      />
      <path
        d="M322 569.4c-1.1 0-2.1-.6-2.7-1.6-3.1-6-8.6-12.4-13.4-17.4.1 4.3-1.2 8.9-5.2 13-1.2 1.2-3.1 1.2-4.2 0s-1.2-3.1 0-4.2c7.6-7.8.5-17.4.2-17.8-.9-1.2-.8-3 .3-4 1.1-1.1 2.8-1.1 4-.1.7.6 16.9 14.6 23.7 27.7.8 1.5.2 3.3-1.3 4-.5.3-.9.4-1.4.4z"
        className="fs_st17"
      />
      <path
        d="M699.4 314.6C697.6 224.9 673.8 237 667 191c-6.9-45.9-20.2-39.8-39.5-35.9-19.3 3.9-19 .3-29.4-12.1-10.4-12.4-42.1-7.5-47.5 4.8-5.3 12.3-22.4 48.7-50.9 79.7-28.5 31.1-25.9 62.7-25.9 62.7s-.1 103.1-.1 137.5c0 15.2.1 60.7.1 60.7 0 10.7 5.7 20.5 14.9 25.9 0 0 117.3 70.2 138.8 65.1v-.3c.9-.2 1.8-.5 2.7-1l59-27.4c6.3-3.5 10.3-10.2 10.3-17.5 0 0 3.2-78.2 3.3-104.4 0-28.7-2.8-85.7-3.4-114.2zm-81.1-84.8c-1.2 2.6-2.5 5-3.8 7.3 0 0-17 5.2-26-13.8s-9.9-64.3 21.7-54.3l8.1 2.7c14 4.6 26.4 3.5 0 58.1z"
        style={{
          fill: "#ddd"
        }}
      />
      <path
        d="M635 368.5c-1.1 0-2.2-.6-2.7-1.7-.7-1.5 0-3.3 1.5-4l46.6-21.7c1.5-.7 3.3 0 4 1.5s0 3.3-1.5 4l-46.6 21.7c-.5.1-.9.2-1.3.2zM635 383.5c-1.1 0-2.2-.6-2.7-1.7-.7-1.5 0-3.3 1.5-4l46.6-21.7c1.5-.7 3.3 0 4 1.5s0 3.3-1.5 4l-46.6 21.7c-.5.1-.9.2-1.3.2zM683.2 519.1c-.9-.6-1.9-.6-2.9-.2l-46.6 21.7c-1.1.5-1.7 1.6-1.7 2.7V558c0 1 .5 2 1.4 2.5.5.3 1.1.5 1.6.5.4 0 .9-.1 1.3-.3l46.6-21.7c1.1-.5 1.7-1.6 1.7-2.7v-14.6c0-1.1-.5-2-1.4-2.6zM595.8 459.4c-.4 0-.8-.1-1.3-.3l-102.7-49.8c-1.5-.7-2.2-2.5-1.5-4s2.5-2.1 4-1.4L597 453.7c1.5.7 2.2 2.5 1.5 4-.4 1.1-1.5 1.7-2.7 1.7zM566.5 462.9c-.4 0-.8-.1-1.3-.3l-52.6-25.5c-1.5-.7-2.2-2.5-1.5-4s2.5-2.1 4-1.4l52.6 25.5c1.5.7 2.2 2.5 1.5 4-.5 1.1-1.6 1.7-2.7 1.7z"
        className="fs_st19"
      />
      <path
        d="m577.3 421.5-59.2-28.3c-1.2-.6-2.2-2.1-2.2-3.3v-54.3c0-1.2 1-1.8 2.2-1.2l59.2 28.3c1.2.6 2.2 2.1 2.2 3.3v54.3c0 1.3-1 1.8-2.2 1.2z"
        className="fs_st20"
      />
      <path
        d="M578.3 424.8c-.7 0-1.5-.2-2.3-.6l-59.2-28.3c-2.3-1.1-3.9-3.7-3.9-6v-54.3c0-1.6.8-3 2-3.8 1.3-.8 3-.8 4.5-.1l59.2 28.3c2.3 1.1 3.9 3.7 3.9 6v54.3c0 1.6-.7 3-2 3.8-.7.4-1.4.7-2.2.7zm.3-6zm-59.7-80.7v51.8c0 .1.3.5.5.6l57.1 27.3V366c0-.1-.3-.5-.5-.6l-57.1-27.3zm-2.1-1z"
        className="fs_st20"
      />
      <path
        d="M625.3 582.6c-27.3 0-126.4-58.8-138-65.8-10.1-5.9-16.4-16.8-16.4-28.5 0-.4-.1-45.7-.1-60.7 0-33.5.1-133.4.1-137.4-.2-2.6-1.7-33.9 26.7-64.8 26.2-28.5 42.8-61.7 50.4-78.9 3.4-7.8 14.3-12 23.2-13.3 9.8-1.4 22.7-.1 29.3 7.8 1.3 1.6 2.5 3 3.5 4.3 6.9 8.6 7.9 9.9 23 6.8 1.2-.2 2.4-.5 3.6-.8 8.8-1.9 17.2-3.7 24.2 1.2 7.4 5.1 12.1 16.8 15.3 38 2.5 17.2 7.5 26 12.8 35.4 8.7 15.3 18.5 32.7 19.6 88.6.2 10.9.8 26 1.4 42 .9 25.5 2 54.5 1.9 72.2-.1 25.7-3.2 101.9-3.3 104.5 0 8.3-4.6 16-11.8 20.1-.1 0-.1.1-.2.1l-58.9 27.4c-.6.3-1.3.6-2 .9-.4.3-.8.6-1.3.7-.9.1-1.9.2-3 .2zm11.1-331.7c.4 0 .8.1 1.2.2 1.5.7 2.2 2.4 1.6 3.9-20.4 47.3-20.7 86.3-20.9 112.1-.4 49.9 0 200.7 0 202.2 0 2.5 1.3 4.7 3.4 6 2.2 1.3 4.8 1.3 7 .1.1 0 .1-.1.2-.1l58.9-27.4c5.3-3 8.7-8.7 8.7-14.8v-.1c0-.8 3.2-78.4 3.3-104.3.1-17.6-1-46.5-1.9-72-.6-16-1.1-31.2-1.4-42.1-1.1-54.4-10.1-70.3-18.8-85.8-5.6-9.9-10.9-19.2-13.6-37.5-2.9-19.1-6.9-29.9-12.7-33.9-4.9-3.4-11.3-2-19.5-.3-1.2.3-2.4.5-3.7.8-17.9 3.6-21 .9-28.9-8.9-1-1.3-2.1-2.6-3.4-4.2-4.1-4.9-13.5-7.2-23.9-5.7-9.1 1.3-16.6 5.2-18.6 9.8-7.7 17.6-24.7 51.4-51.4 80.5-14.2 15.5-20.3 31-22.9 41.4-2.8 11.3-2.3 19-2.3 19v.2c0 1-.1 103.5-.1 137.5 0 15 .1 60.2.1 60.7 0 9.5 5.1 18.5 13.4 23.3 38.2 22.9 95.3 54 123 62.7-.6-1.5-1-3.2-1-5 0-1.5-.4-152.3 0-202.2.2-26.3.5-66 21.3-114.5.6-.9 1.7-1.6 2.9-1.6z"
        className="fs_st19"
      />
      <path
        d="M561.3 280.7c-2.8 0-4.5-.3-4.8-.4-1.6-.3-2.7-1.9-2.3-3.5.3-1.6 1.9-2.7 3.5-2.4.1 0 8.3 1.5 19.4-3.3 14.9-6.4 28.2-21.2 38.6-42.6 12.6-26.1 17.2-41.1 14.4-47.4-1.3-3-4.5-4.1-9.6-5.6l-3-.9c-.6-.2-1.2-.4-1.9-.6-9.7-3.3-27.8-9.5-41.4-1-9.3 5.8-15.1 17.8-17.3 35.7-2 16.5-.8 36.4 27.1 44 1.6.4 2.5 2.1 2.1 3.7-.4 1.6-2.1 2.5-3.7 2.1-36.5-10-32.7-40.5-31.5-50.6 2.4-19.8 9.2-33.2 20.1-40.1 16-10 36.6-2.9 46.5.5.7.2 1.3.4 1.8.6 1 .3 1.9.6 2.9.9 5.4 1.6 10.9 3.3 13.4 9 3.7 8.3-.6 23.5-14.5 52.4-21.7 44.6-48.9 49.5-59.8 49.5zM615.3 370.2c-1.7 0-3-1.4-3-3 .2-26.3.5-66 21.3-114.5.7-1.5 2.4-2.2 3.9-1.6 1.5.7 2.2 2.4 1.6 3.9-20.4 47.3-20.7 86.3-20.9 112.1.1 1.8-1.3 3.1-2.9 3.1z"
        className="fs_st19"
      />
      <path
        d="M609.3 240.7c-6.6 0-17-2.4-23.5-16.1-6.6-14-9.2-41.2 1.6-53.6 3.8-4.4 11.1-8.8 23.7-4.8a3.037 3.037 0 0 1-1.8 5.8c-7.7-2.5-13.4-1.4-17.4 3.1-9 10.3-6.4 35.2-.7 47.1 7.7 16.3 21.8 12.4 22.4 12.2 1.6-.5 3.3.4 3.7 2 .5 1.6-.4 3.2-2 3.7 0-.1-2.4.6-6 .6z"
        className="fs_st19"
      />
      <path
        d="m631.1 154.3-3.6.8c-19.3 3.9-19 .3-29.3-12 0 0 0-.1-.1-.1 0 0-14.4 16-4.6 22.7h.2c10 .7 19.4 4.2 24.6 6 3.3 1.1 6.6 1.9 9.3 3.2l.3.2c-7.2-9.2 3.2-20.8 3.2-20.8z"
        className="fs_st20"
      />
      <path
        d="M627.9 178.1c-.6 0-1.2-.2-1.7-.5l-.1-.1c-1.6-.8-3.6-1.4-5.7-2-1-.3-2-.6-3.1-1l-1.2-.4c-5.1-1.8-13.7-4.8-22.5-5.4h-.1c-.6 0-1.2-.2-1.7-.5-2.7-1.8-4.3-4.4-4.6-7.5-1-8.6 7.7-18.6 8.7-19.7.6-.6 1.4-1 2.2-1 1.1 0 2 .6 2.6 1.4 1.2 1.5 2.3 2.8 3.2 4 6.8 8.5 7.8 9.8 23 6.7l3.5-.8c1.3-.3 2.6.3 3.2 1.4.7 1.1.5 2.5-.4 3.5-.1.1-8.6 9.9-3.1 17 .9 1.2.8 2.8-.2 3.9-.4.7-1.2 1-2 1zm-33.3-15.3c9.4.8 18.2 3.8 23.5 5.7l1.2.4c.9.3 1.9.6 2.9.9.1 0 .2.1.3.1-.4-3 .1-6.3 1.5-9.8.2-.5.4-1 .6-1.4-14.9 2.6-18.1-.4-25.4-9.5-.4-.5-.7-.9-1.1-1.4-2.5 3.4-5.5 8.5-5 12.2.2 1.1.6 2 1.5 2.8zm36.5-8.5zm-35.9-11.2zm0 0zm0 0z"
        className="fs_st20"
      />
      <path
        d="M538.9 575.1c9.6-24.8 29.3-28.2 29.3-28.2-1.1 1.7-7.9 15.8-10.7 28.2"
        className="fs_st16"
      />
      <path
        d="M538.9 578.1c-.4 0-.7-.1-1.1-.2-1.5-.6-2.3-2.3-1.7-3.9 10.1-26.1 30.7-29.9 31.6-30.1 1.2-.2 2.4.3 3 1.3.7 1 .7 2.3 0 3.3-.9 1.3-7.5 15.1-10.3 27.2-.4 1.6-2 2.6-3.6 2.3-1.6-.4-2.6-2-2.3-3.6 1.8-7.8 5.1-16.4 7.7-22.3-6.1 3-15 9.7-20.6 24-.4 1.3-1.5 2-2.7 2z"
        className="fs_st17"
      />
      <path
        d="M538.9 575.1c0-26.7-9.6-53.5-9.6-53.5s1.4 43.1-6.8 63.6"
        className="fs_st16"
      />
      <path
        d="M522.5 588.2c-.4 0-.7-.1-1.1-.2-1.5-.6-2.3-2.4-1.7-3.9 7.9-19.7 6.6-62 6.6-62.4 0-1.5 1-2.8 2.4-3 1.5-.3 2.9.5 3.4 1.9.4 1.1 9.8 27.6 9.8 54.5 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-11.3-1.8-22.7-3.8-31.9-.6 14-2.3 31.8-6.8 43.1-.5 1.2-1.6 1.9-2.8 1.9z"
        className="fs_st17"
      />
      <path
        d="M522.6 585.3c0-13-13.2-31.8-13.2-31.8s6.2 24.2 3.4 31.8"
        className="fs_st16"
      />
      <path
        d="M512.8 588.3c-.3 0-.7-.1-1-.2-1.6-.6-2.4-2.3-1.8-3.9 1.8-4.9-1.2-21-3.5-30-.4-1.4.3-2.9 1.7-3.5 1.3-.6 2.9-.2 3.7 1 .6.8 13.7 19.7 13.7 33.5 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-4.3-1.6-9.4-3.7-14.1.8 5.9 1 11.8-.3 15.2-.4 1.2-1.6 2-2.8 2z"
        className="fs_st17"
      />
    </g>
  </svg>
)
export default FertilizerSmall
